import { render, staticRenderFns } from "./batchNumberDetail.vue?vue&type=template&id=2e9101ab"
import script from "./batchNumberDetail.vue?vue&type=script&lang=js"
export * from "./batchNumberDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9101ab')) {
      api.createRecord('2e9101ab', component.options)
    } else {
      api.reload('2e9101ab', component.options)
    }
    module.hot.accept("./batchNumberDetail.vue?vue&type=template&id=2e9101ab", function () {
      api.rerender('2e9101ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/billCollection/cmp/batchNumberDetail.vue"
export default component.exports